import React, {
  createContext,
  useContext,
  PropsWithChildren,
} from 'react';

interface IEmbedContextValue {
  isEmbedded?: boolean;
  embeddedId?: string;
  embeddedUrl?: string;
}

const DEFAULT_EMBED_CONTEXT_VALUE: IEmbedContextValue = {
  isEmbedded: false,
  embeddedId: undefined,
  embeddedUrl: undefined,
};

const EmbedContext = createContext<IEmbedContextValue>(DEFAULT_EMBED_CONTEXT_VALUE);

export const useEmbedContext = () => {
  const context = useContext(EmbedContext);
  if (!context) {
    throw new Error('useEmbedContext must be used within a EmbedContextProvider');
  }
  return context;
};

interface IEmbedContextProviderProps {
  value: IEmbedContextValue;
}

export const EmbedContextProvider = ({
  value,
  children,
}: PropsWithChildren<IEmbedContextProviderProps>) => {
  return (
    <EmbedContext.Provider value={value}>
      {children}
    </EmbedContext.Provider>
  );
};
